import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RadioItem, RadioOutputItem } from '@core/models/models';

@Component({
  selector: 'caremoni-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss'
})
export class RadioButtonComponent {
  @Input() dataItem: RadioItem = new RadioItem();
  @Input() style = {};
  @Input() isChecked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() styleClass: string = "";
  @Output() onClick = new EventEmitter<RadioOutputItem>();


  @Input()  xdpad?: number = -1;
  @Input()  ydpad?: number = -1;
  @Input()  dpad?: number = -1;
  @Input()  tabdpad?: number = -1;
  @Input()  xtabdpad?: number = -1;
  @Input()  ytabdpad?: number = -1;
  @Input()  scaledpad?: number = -1;

  constructor() { }

  handleClick(event: any) {
    if (this.disabled) return
    this.isChecked = true;

    this.onClick.emit({ data: this.dataItem, value: this.isChecked });
  }
}
